import upgradeImg from "@/assets/svg/upgrade.svg";
import Header from "@/components/Header1/Header";
import { useTranslation } from "react-i18next";
import style from "./index.module.scss";
const UpgradePage = () => {
  const { t } = useTranslation();
  return (
    <div className={style["upgrade-page"]}>
      <Header />
      <div className={style["content-wrapper"]}>
        <img src={upgradeImg} alt="" />
        <div className={style["text1"]}>{t("非常抱歉，系统正在升级")}</div>
        <div className={style["text2"]}>
          {t("预计需要两小时，请稍后再试～")}
        </div>
      </div>
    </div>
  );
};

export default UpgradePage;
